<section class="section-gap AcknowledgementHeader">
  <div class="container">
    <section class="sectionHeader">
      <h2>Acknowledgement</h2>
    </section>
  </div>
</section>
<ng-container *ngIf="showLoader">
  <div class="loaderContentImg" *ngIf="loaderService.isLoading | async"> <!--*ngIf="loaderService.isLoading | async" -->
    <div class="container">
      <img src="../../../assets/main/no-result-found.png" alt="No Result">
      <h4>Payment Waiting...</h4>
    </div>
  </div>
</ng-container>
<section class="section-gap acknowledgementSection" *ngIf="!(loaderService.isLoading | async)">
  <ng-container>
    <div class="container">
      <section class="acknowledgementStatus">
        <div class="bookingWrapper">
          <div class="imgWrapper">
            <img src="../../../../assets/main/bookingStatus.svg" alt="CheapTicket Booking Status" class="img-fluid">
          </div>
          <div class="contentWrapper">
            <ng-container *ngIf="list as item">
              <p class="bookingStatus">BOOKING
                <span *ngIf="item.booking_details.status == 'Confirm'">CONFIRMED</span>
                <span *ngIf="item.booking_details.status == null">Pending</span>
                <span *ngIf="item.booking_details.status == 'Pending'">Pending</span>
                <span *ngIf="item.booking_details.status == 'Fail'">Fail</span>
                <span *ngIf="item.booking_details.status == 'Cancel'">Cancel</span>
                <span *ngIf="item.booking_details.status == 'Modify'">Modify</span>!
              </p>
              <p class="bookingMsg">Thank you for booking with us.</p>
              <p class="bookingCupon">Booking ID : <span>BEL-{{list.booking_details.booking_id}}</span></p>
            </ng-container>
          </div>
        </div>
      </section>
      <section class="ticketDetials">
        <ng-content></ng-content>
      </section>
    </div>
  </ng-container>
</section>
